import React, { useCallback, useEffect, useState } from "react";
import AdminNavigation from "./AdminNavigation";
import Select from "../../forms/Select";
import { validateField } from "../../pages/functions";
import { addNotification as notify } from "reapop";
import { COUNTRIES, REF_DATA } from "../../constants";
import connect from "react-redux/es/connect/connect";
import ReactSelect from "react-select";
import { api_v2 } from "../NewIndex.api";
import { getApplicationRegex } from "../plugins/utils";

const V2SiteExport = (props) => {
  const siteExportFields = {
    affiliate: {
      name: "Affiliate",
      value: "",
      rules: { title: "Affiliate", required: true },
    },
    country: {
      name: "Country",
      value: "",
      rules: { title: "Country", required: true },
    },
    content: {
      name: "Content To Export",
      value: "",
      rules: { title: "Content To Export", required: true },
    },
  };
  const [fields, setFields] = useState(siteExportFields);
  //create content dropdown
  const contentOptions = [
    { value: "Product/Indications", label: "Product/Indications" },
    { value: "TET Data", label: "TET Data" },
    { value: "Portal Functionalities", label: "Portal Functionalities" },
  ];
  const [affiliateOptions, setAffiliateOptions] = useState();
  const [countryOptions, setCountryOptions] = useState();
  const [countryDropdown, setCountryDropdown] = useState();
  const [allCountriesChecked, setAllCountriesChecked] = useState(false);

  const showNotification = (title, message, status) => {
    props.notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };
  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  const validate = useCallback(
    (e, field) => {
      const inputValue = e.target.value.toLowerCase();
      const ref_Data = props.referenceData.find(function (category) {
        return category.type === REF_DATA;
      }).referenceData;
      const regex = getApplicationRegex(ref_Data);

      if (regex.Emoji_Regex !== null && regex.Emoji_Regex.test(inputValue)) {
        // Emoji detected, prevent it from being added
        showNotification(
          "Error!",
          "Special characters are not allowed",
          "error"
        );
        return;
      } else if (regex.Script_Regex !== null && regex.Script_Regex.test(inputValue)) {
        // HTML Tags and Script detected, prevent it from being added
        showNotification(
          "Error!",
          "Submission fails. Input contains prohibited words. Please remove them and try again.",
          "error"
        );
        return;
      } else if (regex.Script_Regex === null || regex.Emoji_Regex === null) {
        showNotification(
          "Error!",
          "Validation configuration is missing. Please contact support.",
          "error"
        );
        return;
      }
      const validateFields = validateField(e, field, fields);
      setFields({ ...validateFields });
    },
    [fields]
  );

  useEffect(() => {
    const countryList = props.referenceData.filter(
      (item) => item.type === COUNTRIES
    )[0].countries;
    const affiliateList = countryList
      .map((c) => c.affiliate)
      .filter(onlyUnique)
      .sort();
    const options = affiliateList.map((affiliate) => ({
      value: affiliate,
      label: affiliate,
    }));
    setAffiliateOptions(options);
  }, [props.referenceData]);

  const handleAffiliateChange = (selected) => {
    // setFields((prevFields) => ({
    //   ...prevFields,
    //   affiliate: {
    //     ...prevFields.affiliate,
    //     value: selected ? selected : "",
    //   },
    //   country: {
    //     ...prevFields.country,
    //     value: "",
    //   },
    //   content: {
    //     ...prevFields.content,
    //     value: "",
    //   },
    // }));
    setFields({
      ...siteExportFields,
      affiliate: {
        ...siteExportFields.affiliate,
        value: selected ? selected : "",
      },
    });
    setCountryDropdown([]);
    setAllCountriesChecked(false);
    let countryRefData = props.referenceData.filter(
      (item) => item.type === COUNTRIES
    )[0].countries;
    let countryList = countryRefData.filter(
      (country) => country.affiliate === selected
    );
    let options = countryList.map((item) => ({
      value: item.name,
      label: item.name,
    }));
    setCountryOptions(options);
  };

  const handleCountryChange = (selectedCountry) => {
    setCountryDropdown(selectedCountry || []);
    setFields((prevFields) => ({
      ...prevFields,
      country: {
        ...prevFields.country,
        value: selectedCountry
          ? selectedCountry.map((option) => option.value)
          : [],
      },
    }));
  };

  const handleContentChange = (selected) => {
    setFields((prevFields) => ({
      ...prevFields,
      content: {
        ...prevFields.content,
        value: selected ? selected: "",
      },
    }));
  };

  const handleAllCountriesChecked = (event) => {
    setAllCountriesChecked(event.target.checked);
  };

  const handleSubmit = useCallback(() => {
    const { affiliate, country, content } = fields;

    if (
      affiliate.value &&
      (allCountriesChecked || countryDropdown.length > 0) &&
      content.value
    ) {
      const payload = {
        affiliate: affiliate.value,
        countries: allCountriesChecked
          ? countryOptions.map((option) => option.value)
          : countryDropdown.map((option) => option.value),
      };

      if (content.value === "Product/Indications") {
        api_v2.exportProducts(payload, (response) => {
          if (response.ok) {
            response.blob().then((blob) => {
              let url = window.URL.createObjectURL(blob);
              let a = document.createElement("a");
              a.href = url;
              // a.download = "Product Reports." + blob.type.split("/")[1];
              a.download = "Product_Reports.xlsx";
              document.body.appendChild(a);
              a.click();
              a.remove();
              showNotification(
                "Success!",
                "Products exported successfully.",
                "success"
              );
            });
          } else {
            showNotification(
              "ERROR!",
              "Product/Indications exported has some problem, please try again after sometime..",
              "error"
            );
          }
        }),
          () =>
            showNotification(
              "ERROR!",
              "Product/Indications exported has some problem, please try again after sometime..",
              "error"
            );
      } else if (content.value === "TET Data") {
        api_v2.exportTET(payload, (response) => {
          if (response.ok) {
            response.blob().then((blob) => {
              let url = window.URL.createObjectURL(blob);
              let a = document.createElement("a");
              a.href = url;
              a.download = "TET Reports." + blob.type.split("/")[1];
              document.body.appendChild(a);
              a.click();
              a.remove();
              showNotification(
                "Success!",
                "TET Data exported successfully.",
                "success"
              );
            });
          } else {
            showNotification(
              "ERROR!",
              "TET data exported has some problem, please try again after sometime..",
              "error"
            );
          }
        }),
          () =>
            showNotification(
              "ERROR!",
              "TET data exported has some problem, please try again after sometime..",
              "error"
            );
      } else if (content.value === "Portal Functionalities") {
        api_v2.exportPortalFunctionality(payload, (response) => {
          if (response.ok) {
            response.blob().then((blob) => {
              let url = window.URL.createObjectURL(blob);
              let a = document.createElement("a");
              a.href = url;
              a.download = "portal_functionality.xlsx";
              document.body.appendChild(a);
              a.click();
              a.remove();
              showNotification(
                "Success!",
                "Portal Functionalities exported successfully.",
                "success"
              );
            });
          } else {
            showNotification(
              "ERROR!",
              "Portal Functionalities exported has some problem, please try again after sometime..",
              "error"
            );
          }
        }),
          () =>
            showNotification(
              "ERROR!",
              "Portal Functionalities exported has some problem, please try again after sometime..",
              "error"
            );
      }
    }
  }, [fields, allCountriesChecked, countryOptions, countryDropdown]);

  return (
    <div className="v2_container">
      <div className="row">
        <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
        <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
          <div className="row">
            <div className="col-12 col-xl-12">
              <h3 className="mb-3 header-primary">Export Site Content</h3>
              <p>Select the content you want to export.</p>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-4">
              <Select
                searchable
                clearable={false}
                options={affiliateOptions}
                field={fields.affiliate}
                validate={(e) => validate(e, fields.affiliate)}
                onChange={(selected) => handleAffiliateChange(selected)}
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-4 ">
              <label className="custom-control custom-checkbox mr-0">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  checked={allCountriesChecked}
                  onChange={(event) => handleAllCountriesChecked(event)}
                />
                <span className="custom-control-indicator" />
                <span className="custom-control-description">
                  All Countries
                </span>
              </label>
            </div>
          </div>
          {!allCountriesChecked && (
            <div className="row mb-4">
              <div className="col-md-4">
                <ReactSelect
                  multi
                  searchable={true}
                  clearable={false}
                  options={countryOptions}
                  value={countryDropdown}
                  onChange={(selected) => handleCountryChange(selected)}
                  placeholder="Select a country..."
                />
              </div>
            </div>
          )}
          <div className="row mb-4">
            <div className="col-md-4">
              <Select
                searchable
                clearable={false}
                options={contentOptions}
                field={fields.content}
                validate={(e) => validate(e, fields.content)}
                onChange={(selected) => handleContentChange(selected)}
              />
            </div>
          </div>
          <div className="row md-4">
            <div className="col-md-4">
              <button
                class="btn btn-lg btn-info btn-rounded save_button"
                onClick={() => handleSubmit()}
                style={{ marginTop: "10px" }}
                disabled={
                  !(
                    fields.affiliate.value &&
                    (allCountriesChecked || countryDropdown.length > 0) &&
                    fields.content.value
                  )
                }
              >
                Export
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  referenceData: state.referenceData,
});

export default connect(mapStateToProps, { notify })(V2SiteExport);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/V2SiteExport.js